
import Lang from '~/lang'

$(() => {
    // Function to create and show the dialog
    function showAlert() {
        // Metro dialog creation for reloading the page
        Metro.dialog.create({
            title: Lang.get("javascript.socket.emergency_browser_reload"),
            content: `
            <div>
                ${Lang.get("javascript.socket.emergency_browser_reload_content")}
            </div>
            `,
            actions: [
                {
                    caption: "OK",
                    cls: "js-dialog-close",
                    onclick: function() {
                        location.reload(); // No need for true parameter
                    }
                }
            ],
            clsDialog: 'metro__dialog',
            overlay: true
        });
    }

    Echo.channel('emergency.page.reload')
        .listen('.App\\Events\\Front\\EmergencyPageReloaded', showAlert);
});
